import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

// Renders AI replies as rich markdown: headings, lists, tables, links,
// bold/italic, blockquotes, inline code, and fenced code blocks with syntax
// highlighting. Used only for completed AI messages (streaming stays plain).
const MarkdownRenderer = ({ text }) => {
  return (
    <div className="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          code({ inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || '');
            if (!inline && match) {
              return (
                <SyntaxHighlighter
                  style={oneDark}
                  language={match[1]}
                  PreTag="div"
                  customStyle={{ margin: '8px 0', borderRadius: '8px', fontSize: '13px' }}
                  {...props}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              );
            }
            return (
              <code className={`md-inline-code ${className || ''}`} {...props}>
                {children}
              </code>
            );
          },
          // Open links in a new tab safely
          a({ node, children, ...props }) {
            return (
              <a target="_blank" rel="noopener noreferrer" {...props}>
                {children}
              </a>
            );
          }
        }}
      >
        {text || ''}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
